import { render, staticRenderFns } from "./UserStatements.vue?vue&type=template&id=e937091a&scoped=true&"
import script from "./UserStatements.vue?vue&type=script&lang=js&"
export * from "./UserStatements.vue?vue&type=script&lang=js&"
import style0 from "./UserStatements.vue?vue&type=style&index=0&id=e937091a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e937091a",
  null
  
)

export default component.exports